import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin';
import { CMSService } from '../../../services/cms-service';
import { BC } from 'model/modal-cms/bc';
import { Router } from '@angular/router';

declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Selectionner  le non et prénoms du malade.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-bc',
  templateUrl: './bc.component.html',
  styleUrls: ['./bc.component.scss']
})
export class BcComponent implements OnInit {

  id_agent_actuel: any;
  data_bc: any = "";
  _bc: BC = new BC(null);
  mode_agent: number = 1;
  listeFamille: any[];
  listeConjointEnfant: any[];
  mode_agent_: number;
  id_aget_cms: any;
  etat_agent: any;
  informationAgentDRHA:any;
  code: string = "ABCDEFghojklm123456789";
  direction_agent_actu:any;
  //test totosoa  336140 

  constructor(public adminService: AdminService, public _CMSService: CMSService, private router: Router) {

     // this.adminService.newCribSubect2.subscribe(
     //        data => {
     //          this.informationAgentDRHA = data;
     //           console.log(" .....................this.informationAgentDRHA...................."+ this.informationAgentDRHA);
              
     //        }
     //      );
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    //this.id_agent_actuel = 232;

  }

  ngOnInit() {
    this.listAllBc();
      this.listeWSDrh2();
     
  }

  recupererIdAgentCMSData() {
    this.adminService.getlisteFamille(this.id_agent_actuel)
      .subscribe(data => {
        if (data.length == 0) {
          this.listeFamille = []
        } else if (data.length != 0) {
          this.listeFamille = data;

        }
      }, err => {

      })
  }

  listeWSDrh2() {
    this.adminService.getlisteWSDrh2(this.id_agent_actuel, this.code)
      .subscribe(data => {
       this.informationAgentDRHA= data;
        console.log(" this.informationAgentDRHA"+ data);
         this.recupererIdAgentCMSData();
      }, err => {
        console.log(err);
      });
    //save user connected

  }

  //http://10.2.250.161:7001/cms/ws/agent_et_famille?im=340909   cas ecd
  // this.adminService.getlisteFamille(this.id_agent_actuel)
  //par id : http://10.2.250.186:7001/cms/chercherConjoint_et_Enfant_agent?id=232
  recupererAgentFamille() {
    this.adminService.getAlllisteFamille(this.id_aget_cms)
      .subscribe(data => {
        if (data.length == 0) {
          this.mode_agent_ = 1;
        } else if (data.length != 0) {
          this.listeConjointEnfant = data;
          console.log(this.listeConjointEnfant);
          this.mode_agent_ = 2;
        }
      }, err => {

      })
  }



  listAllBc() {
    this._CMSService.getBCAgentByIM(this.id_agent_actuel)
      .subscribe(data => {
        console.log(data);
        this.data_bc = data
      },
        err => {
          console.log(err);
        })
  }

  getInfoBC(id_bc: any) {
    this._CMSService.getInfoBc(id_bc)
      .subscribe(data => {
        console.log(data);
        if (this._bc.etat_bc == "V" || this._bc.etat_bc == "U" || this._bc.etat_bc == "R") {
          this.router.navigate(['detail-bc/' + id_bc]);
        } else if (this._bc.etat_bc == "A") {
          this._bc = data;
        }
      },
        err => {
          console.log(err);
        })
  }


  onChange(deviceValue, t, dirct) {
    console.log(deviceValue);
    console.log(t);
    console.log(dirct);
   
    if(dirct=="DIRECTION ADMINISTRATIVE ET FINANCIERE"){
         this.direction_agent_actu = "DAF";
    }else if(dirct=="DIRECTION DES SYSTEMES D'INFORMATION"){
         this.direction_agent_actu = "DSI";
    }else if(dirct=="DIRECTION DES RESSOURCES HUMAINES"){
         this.direction_agent_actu = "DRH";
    }else{
      this.direction_agent_actu = dirct;
    }
    this.id_aget_cms = t;
    this.etat_agent = deviceValue
    if (deviceValue == "Malade") {
      this.mode_agent = 1;
      this._bc.info_patient = "Agent lui-même";
    } else if (deviceValue == "Non malade") {
      this.mode_agent = 2;
      this.recupererAgentFamille();
    }
  }




  SaveBC() {
    if(this.etat_agent == "Agent lui-même" && this.etat_agent == "Non malade"){
      error_message.show();
    }else{
      if (this._bc.id_bc == null ) {
        this._bc.im = this.id_agent_actuel
        this._bc.dir_agent = this.direction_agent_actu
        this._CMSService.saveBc(this._bc).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          this.listAllBc();
          this._bc = new BC(null)
          success_message.show();
        }, err => {
        })
      } else {
        this._CMSService.updateBc(this._bc).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          this.listAllBc();
          this._bc = new BC(null)
          success_message.show();
        }, err => {
        })
      }
    }
   

  }


}
